import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router';
import { App } from './App';
import { AuthProvider } from './auth/AuthContext';
import './styles/base.css';
import './styles/components.css';

// Tras un despliegue, una pestaña abierta puede pedir chunks que ya no existen: recarga una vez
// para tomar la versión nueva (la marca evita un ciclo si el error persiste).
window.addEventListener('vite:preloadError', (event) => {
  try {
    const last = Number(sessionStorage.getItem('chunkReloadAt') ?? 0);
    if (Date.now() - last < 30_000) return;
    sessionStorage.setItem('chunkReloadAt', String(Date.now()));
  } catch {
    // Sin sessionStorage: se recarga igual.
  }
  event.preventDefault();
  window.location.reload();
});

const root = document.getElementById('root');
if (!root) throw new Error('No se encontró #root');

createRoot(root).render(
  <StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <App />
      </AuthProvider>
    </BrowserRouter>
  </StrictMode>,
);
